import Vue from 'vue';
import VueRouter from 'vue-router';
import NotFound from '../views/NotFound';
import AdminRoute from './admin';
import MrtRoute from './mrt';
import { Hub, Logger } from 'aws-amplify';
import store from '../store';

Vue.use(VueRouter);

const logger = new Logger('router');
const DEFAULT_ROUTE_NAME = 'home';

// ルーティング定義
const route = [
  {
    path: '/notfound',
    name: 'notfound',
    component: NotFound,
  },
];

// ルートをマージする（管理画面、掲示板）
const routes = [...AdminRoute, ...MrtRoute, ...route];

// ルーター定義
const router = new VueRouter({
  mode: 'history',
  routes,
  // 画面遷移時に最上部にスクロール
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// 認証の状態監視
const authListener = (data) => {
  switch (data.payload.event) {
    case 'signIn':
      // 認証された
      logger.info('user signed in');
      // ログイン
      store.dispatch('login', { auth: data.payload }).then(() => {
        logger.info('store.loggedIn', store.getters.loggedIn);
        // 初期ページの復元
        store.dispatch('restoreInitialRoute').then(() => {
          const initialRoute = store.getters.initialRoute;
          // 初期ページへ
          if (!initialRoute || initialRoute.path ===
              '/' || initialRoute.path.includes('login')) {
            router.push({ name: DEFAULT_ROUTE_NAME });
          } else {
            router.push(initialRoute);
          }
        });
      });
      break;
    case 'signUp':
      logger.info('user signed up');
      break;
    case 'signOut':
      logger.info('user signed out');
      break;
    case 'signIn_failure':
      logger.error('user sign in failed');
      break;
    case 'tokenRefresh':
      logger.info('token refresh succeeded');
      break;
    case 'tokenRefresh_failure':
      logger.error('token refresh failed');
      break;
    case 'configured':
      logger.info('the Auth module is configured');
  }

  logger.info('authListener.data', data);
};
Hub.listen('auth', authListener);

// ルーティングの解決
router.beforeResolve(((to, from, next) => {
  logger.info(
    'beforeResolve to:', to.path, 'next: ', next.name, 'code:', to.query.code,
  );

  logger.info('loggedIn', store.getters.loggedIn);

  // login以外の場合のみ
  // 最初にアクセスされたURLを保持する
  if (!to.path.includes('login')) {
    store.dispatch('setInitialRoute', { path: to.path, params: to.params });
  }

  // 画面のタイトル設定
  store.dispatch('setPageTitle', to.meta.title);

  // ログインされていない場合はログイン画面へ
  if (to.name !== 'login' && !store.getters.loggedIn) {
    logger.info('認証が必要なためログインへ');
    return next({ name: 'login' });
  }

  // ルートの場合の遷移
  if (to.path === '/') {
    return (store.getters.loggedIn) ? next({ name: DEFAULT_ROUTE_NAME }) : next(
      { name: 'login' });
  }

  // 存在しないパス
  if (!to.matched.length) {
    return next({ name: 'notfound' });
  }

  logger.info('next');

  next();
}));

export default router;
